export default interface SyncLog {
    externalSystemSyncId: string
    syncedAt: Date
    syncLogStatusId: string
    startAt: Date
    finishedAt: Date
}


export enum SyncLogTypes {
    JOB_TITLE_DAYFORCE = "job_title_dayforce",
    OPPORTUNITY_ACUMATICA = "opportunity_acumatica",
    EMPLOYEE_DAYFORCE = "employee_dayforce",
    REVENUE_IBEX = "department_finance_ibexiq",
    PROJECTS = "project_acumatica",
    GROSS_MARGIN_REPORT = "gross_margin_report_ibexiq",
    BILLABILITY_REPORT = "billability_report_ibexiq"
}
